import { render, staticRenderFns } from "./DelistingNotice.vue?vue&type=template&id=3835b638&scoped=true"
import script from "./DelistingNotice.vue?vue&type=script&lang=js"
export * from "./DelistingNotice.vue?vue&type=script&lang=js"
import style0 from "./DelistingNotice.vue?vue&type=style&index=0&id=3835b638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835b638",
  null
  
)

export default component.exports